// Shared platform display metadata (label/color/icon), keyed by the exact
// lowercase provider platform strings the real Buffer/Postiz/YouTube APIs
// return (e.g. 'instagram-standalone', not just 'instagram').
// `abbr` is a short, high-contrast text badge (not an emoji) — emoji glyphs
// render inconsistently across OS/browser font sets and were effectively
// invisible/unrecognizable at the small pill size the calendar uses. A
// colored badge with a 1-2 letter mark renders identically everywhere.
export const PLATFORM_STYLE = {
  tiktok: { label: 'TikTok', color: '#010101', icon: '🎵', abbr: 'TT' },
  facebook: { label: 'Facebook', color: '#1877F2', icon: '👥', abbr: 'FB' },
  linkedin: { label: 'LinkedIn', color: '#0A66C2', icon: '💼', abbr: 'in' },
  bluesky: { label: 'Bluesky', color: '#0085FF', icon: '🦋', abbr: 'BS' },
  mastodon: { label: 'Mastodon', color: '#6364FF', icon: '🐘', abbr: 'M' },
  'instagram-standalone': { label: 'Instagram', color: '#E1306C', icon: '📸', abbr: 'IG' },
  instagram: { label: 'Instagram', color: '#E1306C', icon: '📸', abbr: 'IG' },
  threads: { label: 'Threads', color: '#000000', icon: '🧵', abbr: '@' },
  x: { label: 'X', color: '#000000', icon: '🐦', abbr: 'X' },
  twitter: { label: 'X', color: '#000000', icon: '🐦', abbr: 'X' },
  youtube: { label: 'YouTube', color: '#FF0000', icon: '▶️', abbr: '▶' },
  pinterest: { label: 'Pinterest', color: '#E60023', icon: '📌', abbr: 'P' },
};

export function platformStyle(platform) {
  const key = (platform || '').toLowerCase();
  return PLATFORM_STYLE[key] || { label: platform || 'Unknown', color: '#64748b', icon: '📱', abbr: '?' };
}
